import { useEffect } from 'react';
import { Navigate, useRouteError } from 'react-router-dom';

import { analytics } from 'analytics';

import ErrorPage from '../components/ErrorPage';
import Page from '../components/Page';
import PageFooter from '../components/PageFooter';
import TopNavBar from '../components/TopNavBar';
import { useAppEnvironmentContext } from '../contexts/appEnvironmentContext';
import { Path } from '../utils/routes';

type Props = {
  withHeader?: boolean;
  withFooter?: boolean;
};

const NotFoundPage: React.FC<Props> = ({ withHeader, withFooter }) => {
  const { appEnvironment } = useAppEnvironmentContext();
  const routeError = useRouteError();

  // Report any route error to Sentry if there is one
  useEffect(() => {
    if (routeError) {
      analytics.reportError('Route error', { routeError }, false);
    }
  }, [routeError]);

  // If in the add-in, redirect any missing page to the home page silently
  if (appEnvironment === 'office') {
    return <Navigate to={Path.AddinHome} replace />;
  }

  return (
    <Page>
      {withHeader && <TopNavBar />}
      <ErrorPage title="The page you are looking for is not here" />
      {withFooter && <PageFooter />}
    </Page>
  );
};

export default NotFoundPage;
